import { defineMessages } from 'react-intl';

export default defineMessages({
  taxPaid: {
    description: 'filterOptions.shipping-taxPaid',
    defaultMessage: 'Tax Paid',
    id: 'n7iRuM',
  },
  store: {
    description: 'filterOptions.shipping-store',
    defaultMessage: 'Store',
    id: 'nLO4+U',
  },
  state: {
    description: 'filterOptions.shipping-state',
    defaultMessage: 'State',
    id: 'pTRvjo',
  },
  source: {
    description: 'filterOptions.shipping-source',
    defaultMessage: 'Source',
    id: 'KiiWg8',
  },
  shippingPaid: {
    description: 'filterOptions.shipping-shippingPaid',
    defaultMessage: 'Shipping Paid',
    id: 'xU0Bz4',
  },
  shippingAccount: {
    description: 'filterOptions.shipping-shippingAccount',
    defaultMessage: 'Shipping Account',
    id: '85A1SO',
  },
  shipmentNumber: {
    description: 'filterOptions.shipping-shipmentNumber',
    defaultMessage: 'Shipment #',
    id: 'ZGOBe9',
  },
  shipmentNotification: {
    description: 'filterOptions.shipping-shipmentNotification',
    defaultMessage: 'Shipment Notification',
    id: '400G5d',
  },
  shipFrom: {
    description: 'filterOptions.shipping-shipFrom',
    defaultMessage: 'Ship From',
    id: '9exK7T',
  },
  shipDate: {
    description: 'filterOptions.shipping-shipDate',
    defaultMessage: 'Ship Date',
    id: 'Im5jQe',
  },
  service: {
    description: 'filterOptions.shipping-service',
    defaultMessage: 'Service',
    id: 'OjDUbX',
  },
  recipientName: {
    description: 'filterOptions.shipping-recipientName',
    defaultMessage: 'Recipient Name',
    id: 'q2DnUk',
  },
  rate: {
    description: 'filterOptions.shipping-rate',
    defaultMessage: 'Rate',
    id: 'MH0tlQ',
  },
  quantity: {
    description: 'filterOptions.shipping-quantity',
    defaultMessage: 'Quantity',
    id: 'jIZMbM',
  },
  provider: {
    description: 'filterOptions.shipping-provider',
    defaultMessage: 'Provider',
    id: 'mSUhEO',
  },
  postalCode: {
    description: 'filterOptions.shipping-postalCode',
    defaultMessage: 'Postal Code',
    id: 'rBg1/o',
  },
  packingSlip: {
    description: 'filterOptions.shipping-packingSlip',
    defaultMessage: 'Packing Slip',
    id: 'OoQtSc',
  },
  package: {
    description: 'filterOptions.shipping-package',
    defaultMessage: 'Package',
    id: '79WNyT',
  },
  orderNumber: {
    description: 'filterOptions.shipping-orderNumber',
    defaultMessage: 'Order #',
    id: 'CtXXHM',
  },
  orderDate: {
    description: 'filterOptions.shipping-orderDate',
    defaultMessage: 'Order Date',
    id: 'DXk8KF',
  },
  marketplaceNotification: {
    description: 'filterOptions.shipping-marketplaceNotification',
    defaultMessage: 'Marketplace Notification',
    id: 'NrbyV5',
  },
  labelPrinted: {
    description: 'filter options label printed',
    defaultMessage: 'Label Printed',
    id: 'Ero44D',
  },
  insuranceFee: {
    description: 'filterOptions.shipping-insuranceFee',
    defaultMessage: 'Insurance Fee',
    id: '2DerzR',
  },
  insurance: {
    description: 'filterOptions.shipping-insurance',
    defaultMessage: 'Insurance',
    id: 'HXVHZa',
  },
  deliveryNotification: {
    description: 'filterOptions.shipping-deliveryNotification',
    defaultMessage: 'Delivery Notification',
    id: '7rgndC',
  },
  destination: {
    description: 'filterOptions.shipping-destination',
    defaultMessage: 'Destination',
    id: 'p2cSSV',
  },
  datePaid: {
    description: 'filterOptions.shipping-datePaid',
    defaultMessage: 'Date Paid',
    id: 'IFh9RY',
  },
  createdDate: {
    description: 'filterOptions.shipping-createdDate',
    defaultMessage: 'Created Date',
    id: 'rjkDHV',
  },
  closedDate: {
    description: 'filterOptions.shipping-closedDate',
    defaultMessage: 'Closed Date',
    id: 'ljKtgC',
  },
  country: {
    description: 'filterOptions.shipping-country',
    defaultMessage: 'Country',
    id: 'zd8cCG',
  },
  company: {
    description: 'filterOptions.shipping-company',
    defaultMessage: 'Company',
    id: 'aGUdMc',
  },
  city: {
    description: 'filterOptions.shipping-city',
    defaultMessage: 'City',
    id: 'PBCV3y',
  },
  carrier: {
    description: 'filterOptions.shipping-carrier',
    defaultMessage: 'Carrier',
    id: 'P3H4nR',
  },
  assignedTo: {
    description: 'filterOptions.shipping-assignedTo',
    defaultMessage: 'Assigned To',
    id: '8OQQUh',
  },
  amountPaid: {
    description: 'filterOptions.shipping-amountPaid',
    defaultMessage: 'Amount Paid',
    id: 'Af9UzB',
  },
  rateShopper: {
    description: 'Display text for the Rate Shopper filter',
    defaultMessage: 'Rate Shopper',
    id: 'poKnLy',
  },
  refundStatus: {
    description: 'Display text for the Refund Status filter',
    defaultMessage: 'Refund Status',
    id: 'TqpvXU',
  },
  voidTypeFilterLabel: {
    description: 'Display text for the Void Type filter',
    defaultMessage: 'Void Type',
    id: 'xIs9N+',
  },
  pendingCustomsDocuments: {
    description: 'Display text for the Pending Customs Documents filter in the Shipments grid',
    defaultMessage: 'Pending Customs Documents',
    id: 'BL6llL',
  },
});
